import type { DashboardHealthItem } from '../../creativestudio/framework';
import { cn } from '../../lib/cn';

type Props = { metrics?: DashboardHealthItem[] };

function statusColor(status: DashboardHealthItem['status']) {
  switch (status) {
    case 'healthy': return 'border-success-200 bg-success-50 text-success-700 dark:border-success-900 dark:bg-success-950 dark:text-success-300';
    case 'warning': return 'border-warning-200 bg-warning-50 text-warning-700 dark:border-warning-900 dark:bg-warning-950 dark:text-warning-300';
    case 'error': return 'border-error-200 bg-error-50 text-error-700 dark:border-error-900 dark:bg-error-950 dark:text-error-300';
    default: return 'border-purple-200 bg-purple-50 text-purple-700 dark:border-purple-900 dark:bg-purple-950 dark:text-purple-300';
  }
}

export function CreativeDashboardPanel({ metrics = [] }: Props) {
  return (
    <div className="grid gap-3 grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
      {metrics.map((m) => (
        <div key={m.label} className={cn('rounded-lg border p-3', statusColor(m.status))}>
          <p className="text-2xl font-semibold">{m.score}{m.status === 'info' ? '' : '%'}</p>
          <p className="mt-0.5 text-xs font-medium">{m.label}</p>
        </div>
      ))}
    </div>
  );
}
